var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.dataList),function(suborder){return _c('li',{key:suborder.point_id},[_c('GeocodingUlItem',{attrs:{"suborder":suborder,"dateRange":_vm.dateRange},on:{"AddExamples":_vm.AddExamples,"selected":function($event){return _vm.selectFunc(suborder)}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }